import "angular-datepicker/dist/angular-datepicker.js";
export default 'datePicker'